import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import NotFoundPage from './NotFoundPage';
import AnimatedSection from '../components/AnimatedSection';
import Lightbox from "yet-another-react-lightbox";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import { db } from '../firebase';
import { FaInstagram, FaArrowLeft, FaImages, FaTiktok, FaShareAlt } from 'react-icons/fa'; // Import ikon Instagram & Arrow
import { collection, query, where, getDocs, limit, orderBy } from 'firebase/firestore';
import SEO from '../components/SEO';
// Import Swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import '../components/styles.css';
import './BeritaDetailPage.css'; // Import CSS khusus halaman detail berita

const getCategoryColor = (categoryName) => {
  const colors = ['#e74c3c','#3498db','#2ecc71','#f39c12','#9b59b6','#1abc9c','#e67e22','#34495e', '#d35400', '#c0392b'];
  if (!categoryName) return colors[0];
  let hash = 0;
  for (let i = 0; i < categoryName.length; i++) {
    hash = categoryName.charCodeAt(i) + ((hash << 5) - hash);
  }
  return colors[Math.abs(hash) % colors.length];
};

const getYouTubeEmbedUrl = (url) => {
  if (!url) return null;
  let videoId;
  try {
    // Handles youtu.be/, youtube.com/watch?v=, youtube.com/embed/
    const urlObj = new URL(url);
    if (urlObj.hostname === 'youtu.be') {
      videoId = urlObj.pathname.slice(1);
    } else if (urlObj.hostname.includes('youtube.com')) {
      if (urlObj.pathname.includes('/embed/')) {
        videoId = urlObj.pathname.split('/embed/')[1];
      } else {
        videoId = urlObj.searchParams.get('v');
      }
    }
  } catch (error) {
    console.error("Invalid URL for YouTube parsing:", error);
    return null;
  }

  return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
};

// Komponen untuk menampilkan Kartu Album Terkait
const LinkedAlbumCard = ({ slug }) => {
  const [album, setAlbum] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAlbum = async () => {
      try {
        const q = query(collection(db, 'galeri_kategori'), where("slug", "==", slug));
        const snapshot = await getDocs(q);
        if (!snapshot.empty) {
          setAlbum({ id: snapshot.docs[0].id, ...snapshot.docs[0].data() });
        }
      } catch (err) {
        console.error("Gagal memuat album linked:", err);
      } finally {
        setLoading(false);
      }
    };
    if (slug) fetchAlbum();
  }, [slug]);

  if (loading) return null;
  if (!album) return null;

  return (
    <div className="berita-detail-gallery" style={{ marginTop: '40px' }}>
      <h3 style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '1.5rem', marginBottom: '20px' }}>
        <FaImages style={{ color: '#F59E0B' }} /> Galeri Foto Kegiatan
      </h3>
      <div className="linked-album-card" style={{
        backgroundColor: '#fff',
        borderRadius: '16px',
        overflow: 'hidden',
        boxShadow: '0 10px 25px rgba(0,0,0,0.08)',
        border: '1px solid #f1f5f9',
        display: 'flex',
        flexDirection: 'column', // Mobile first
        maxWidth: '100%',
      }}>
        <div style={{ position: 'relative', height: '250px', overflow: 'hidden' }}>
          <img
            src={album.imageUrl || 'https://via.placeholder.com/800x400?text=Album+Cover'}
            alt={album.name}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
          <div style={{
            position: 'absolute', inset: 0,
            background: 'linear-gradient(to top, rgba(0,0,0,0.7), transparent)',
            display: 'flex', alignItems: 'flex-end', padding: '20px'
          }}>
            <h4 style={{ color: '#fff', margin: 0, fontSize: '1.4rem', textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}>{album.name}</h4>
          </div>
        </div>
        <div style={{ padding: '25px', display: 'flex', flexDirection: 'column', gap: '15px', alignItems: 'center', textAlign: 'center' }}>
          <p style={{ color: '#64748b', lineHeight: '1.6', margin: 0 }}>
            {album.description || 'Lihat dokumentasi lengkap kegiatan ini.'}
          </p>
          {album.externalLink && (
            <a
              href={album.externalLink}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '10px',
                alignSelf: 'center', fontWeight: 'bold', textDecoration: 'none',
                padding: '12px 24px', borderRadius: '30px',
                backgroundColor: '#2563EB', color: 'white',
                boxShadow: '0 4px 12px rgba(37, 99, 235, 0.3)'
              }}
            >
              <FaImages /> Lihat Album Lengkap
            </a>
          )}
        </div>
      </div>
    </div>
  );
};


const BeritaDetailPage = () => {
  const { slug } = useParams();
  const [berita, setBerita] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tiktokEmbedHtml, setTiktokEmbedHtml] = useState('');
  const [error, setError] = useState(false);
  const [galleryImages, setGalleryImages] = useState([]);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);
  const [relatedBerita, setRelatedBerita] = useState([]);
  const [categoryColor, setCategoryColor] = useState(null);

  useEffect(() => {
    const fetchBerita = async () => {
      setLoading(true);
      try {
        const q = query(
          collection(db, "berita"),
          where("slug", "==", slug),
          where("status", "==", "published"),
          limit(1)
        );
        const querySnapshot = await getDocs(q);
        if (querySnapshot.empty) {
          setError(true);
        } else {
          const beritaData = { id: querySnapshot.docs[0].id, ...querySnapshot.docs[0].data() };
          setBerita(beritaData);

          // Ambil warna kategori
          if (beritaData.category) {
            const categoryQuery = query(collection(db, 'berita_kategori'), where("name", "==", beritaData.category), limit(1));
            const categorySnapshot = await getDocs(categoryQuery);
            if (!categorySnapshot.empty) {
               setCategoryColor(categorySnapshot.docs[0].data().color);
            }
          }

          // Jika ada link TikTok, ambil HTML embed-nya
          if (beritaData.tiktokLink) {
            const oembedUrl = `https://www.tiktok.com/oembed?url=${encodeURIComponent(beritaData.tiktokLink)}`;
            fetch(oembedUrl)
              .then(res => res.json())
              .then(data => setTiktokEmbedHtml(data.html))
              .catch(err => console.error("Gagal mengambil TikTok embed:", err));
          }

          // Jika ada galeri tertaut, ambil gambar-gambarnya
          if (beritaData.linkedGallery) {
            const categoryQuery = query(collection(db, 'galeri_kategori'), where("slug", "==", beritaData.linkedGallery));
            const categorySnapshot = await getDocs(categoryQuery);
            if (!categorySnapshot.empty) {
              const categoryName = categorySnapshot.docs[0].data().name;
              const imagesQuery = query(collection(db, 'galeri'), where("category", "==", categoryName), orderBy("order", "asc"));
              const imagesSnapshot = await getDocs(imagesQuery);
              const imagesData = imagesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
              setGalleryImages(imagesData);
            }
          }

          // Ambil berita terkait (3 berita terbaru selain yang ini)
          const relatedQuery = query(
            collection(db, "berita"),
            where("slug", "!=", slug),
            where("status", "==", "published"),
            orderBy("date", "desc"),
            limit(3));
          const relatedSnapshot = await getDocs(relatedQuery);
          setRelatedBerita(relatedSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        }
      } catch (e) {
        console.error("Error fetching document: ", e);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchBerita();
  }, [slug]);

  // Load TikTok Script Dynamically
  useEffect(() => {
    if (berita?.tiktokLink && tiktokEmbedHtml) {
      const scriptId = 'tiktok-embed-script';
      if (!document.getElementById(scriptId)) {
        const script = document.createElement('script');
        script.id = scriptId;
        script.src = 'https://www.tiktok.com/embed.js';
        script.async = true;
        document.body.appendChild(script);
      }
    }
  }, [berita, tiktokEmbedHtml]);

  const handleShare = async () => {
    const shareData = {
      title: berita.title,
      text: berita.excerpt,
      url: window.location.href,
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (err) {
        console.error("Error sharing:", err);
      }
    } else {
      // Fallback untuk browser yang tidak mendukung Web Share API
      navigator.clipboard.writeText(window.location.href);
      alert("Tautan berita telah disalin ke clipboard!");
    }
  };

  const openLightbox = (index) => {
    setImageIndex(index);
    setLightboxOpen(true);
  };

  if (error) {
    return <NotFoundPage />;
  }

  return (
    <>
      <SEO
        title={berita ? `${berita.title} - Berita SMK Pariwisata Sumbangsih` : "Berita SMK Pariwisata Sumbangsih"}
        description={berita ? (berita.excerpt || berita.title) : "Halaman berita dan kegiatan SMK Pariwisata Sumbangsih"}
      />
      {loading ? (
        <section className="section"><div className="container" style={{ textAlign: 'center' }}>Memuat berita...</div></section>
      ) : !berita ? (
        <NotFoundPage />
      ) : (
        <AnimatedSection>
          <section className="section">
            <div className="container berita-detail-container">
              <article className="berita-detail-content">
                <h1 style={{ textAlign: berita.titleAlignment || 'left', color: berita.titleColor || '#0f172a' }}>{berita.title}</h1> {/* Perataan & Warna Judul */}
                <div className="berita-meta">
                  <span>Oleh: {berita.author}</span> | <span>{new Date(berita.date).toLocaleDateString('id-ID', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</span>
                  {berita.category && (
                    <span className="berita-detail-category" style={{ backgroundColor: categoryColor || getCategoryColor(berita.category) }}>{berita.category}</span>
                  )}
                </div>

                {/* Prioritas: YouTube > TikTok > Gambar Unggulan */}
                {getYouTubeEmbedUrl(berita.videoUrl) ? (
                  <div className="berita-video-wrapper">
                    <iframe
                      src={getYouTubeEmbedUrl(berita.videoUrl)}
                      title={berita.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                ) : tiktokEmbedHtml ? (
                  <div className="berita-tiktok-wrapper" dangerouslySetInnerHTML={{ __html: tiktokEmbedHtml }} />
                ) : (
                  <img src={berita.image} alt={berita.title} className="berita-detail-image" />
                )}

                <div
                  className="berita-full-content"
                  style={{ textAlign: berita.contentAlignment || 'left' }} // Perbaikan: Terapkan perataan konten
                  dangerouslySetInnerHTML={{ __html: berita.content }}
                />

                {/* --- BAGIAN GALERI TERTAUT (ALBUM) --- */}
                {galleryImages.length > 0 ? (
                  // KONDISI 1: Jika masih ada image individual (Legacy / Internal)
                  <div className="berita-detail-gallery">
                    <h3><FaImages /> Galeri Terkait</h3>
                    <Swiper
                      modules={[Navigation, Pagination, A11y]}
                      spaceBetween={15}
                      slidesPerView={1}
                      navigation
                      pagination={{ clickable: true }}
                      breakpoints={{
                        640: { slidesPerView: 2, spaceBetween: 20 },
                        1024: { slidesPerView: 3, spaceBetween: 20 },
                      }}
                      className="berita-gallery-slider"
                    >
                      {galleryImages.map((image, index) => (
                        <SwiperSlide
                          key={image.id}
                          className="gallery-slider-item"
                          onClick={() => openLightbox(index)}
                        >
                          <img src={image.url} alt={image.title || 'Galeri Berita'} loading="lazy" />
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                ) : berita && berita.linkedGallery && (
                  // KONDISI 2: Jika tidak ada image individual, tapi ada Linked Album (External)
                  // Kita perlu fetch data album-nya (sudah dilakukan di useEffect tapi perlu disimpan di state)
                  <LinkedAlbumCard slug={berita.linkedGallery} />
                )}

                {/* --- Section Berita Terkait --- */}
                {relatedBerita.length > 0 && (
                  <div className="related-berita-section">
                    <h3>Berita Lainnya</h3>
                    <Swiper
                      modules={[Navigation, Pagination, A11y]}
                      spaceBetween={15}
                      slidesPerView={1}
                      navigation
                      pagination={{ clickable: true }}
                      breakpoints={{
                        640: { slidesPerView: 2, spaceBetween: 20 },
                        1024: { slidesPerView: 3, spaceBetween: 20 },
                      }}
                      className="related-berita-slider"
                    >
                      {relatedBerita.map(item => (
                        <SwiperSlide key={item.id}>
                          <Link to={`/berita/${item.slug}`} className="related-berita-card">
                            <img src={item.image} alt={item.title} loading="lazy" className="related-berita-image" />
                            <div className="related-berita-content">
                              <h4>{item.title}</h4>
                              <span className="related-berita-date">
                                {new Date(item.date).toLocaleDateString('id-ID', { year: 'numeric', month: 'long', day: 'numeric' })}
                              </span>
                            </div>
                          </Link>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                )}

                <div className="berita-detail-footer">
                  <Link to="/berita" className="btn-back">
                    <FaArrowLeft /> <span>Kembali ke Daftar Berita</span>
                  </Link>
                  {berita.tiktokLink && (
                    <a href={berita.tiktokLink} target="_blank" rel="noopener noreferrer" className="social-share-link tiktok">
                      <FaTiktok /> <span>Lihat di TikTok</span>
                    </a>
                  )}
                  <div className="social-share-container">
                    <button onClick={handleShare} className="social-share-link share">
                      <FaShareAlt /> <span>Bagikan</span>
                    </button>
                    {berita.instagramLink && (
                      <a href={berita.instagramLink} target="_blank" rel="noopener noreferrer" className="social-share-link">
                        <FaInstagram />
                      </a>
                    )}
                  </div>
                </div>
              </article>
            </div>

            <Lightbox
              open={lightboxOpen}
              close={() => setLightboxOpen(false)}
              slides={galleryImages.map(img => ({ src: img.url, title: img.title, description: img.description }))}
              index={imageIndex}
              plugins={[Captions, Zoom]}
              click={(api) => api.toggleControls()}
              zoom={{
                scrollToZoom: true,
                maxZoomPixelRatio: 5,
                click: 0, // Menonaktifkan zoom saat klik tunggal
              }}
              animation={{
                zoom: 500, // Menambahkan animasi zoom dengan durasi 500ms
                swipe: 250,
              }}
            />
          </section>
        </AnimatedSection>
      )}
    </>
  );
};

export default BeritaDetailPage;